import { z } from 'zod';

export const KscanSignalSeverity = z.enum(['advisory', 'warning', 'critical']);
export const KscanSignalDomain = z.enum([
  'regulatory', 'market', 'supplier', 'geopolitical', 'technology', 'climate', 'labor',
]);

export const KscanObservation = z.object({
  id: z.string(),                            // ULID
  tenantId: z.string().default('platform'),
  domain: KscanSignalDomain,
  severity: KscanSignalSeverity,
  headline: z.string().max(120),
  body: z.string().max(1500),
  factorsCited: z.array(z.string()).default([]),
  affectedTenantTiers: z.array(z.string()).default([]),
  confidence: z.number().min(0).max(1),
  sourceRefs: z.array(z.object({
    kind: z.enum(['url', 'doc-entry', 'operator-report']),
    ref: z.string(),
  })).default([]),
  observedAt: z.string(),
  correlationId: z.string(),
  softDeleted: z.literal(false),             // append-only invariant
});

/** @typedef {import('zod').infer<typeof KscanObservation>} KscanObservationType */
